import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EResetSeoUrlsActionType {
  Reset = 'seoUrls/resetSeoUrls',
}

export type TResetSeoUrls = ITypedReduxAction<EResetSeoUrlsActionType.Reset>;
